
const ssoHost  = "https://auth.myotto.fr";
const ssoDomain = ".myotto.fr";


//  *************************************************************************************************************
//  * function API GET sur /login
// **************************************************************************************************************
export function apiSsoLogin (callback)
{
    var apiurl = ssoHost + "/login";
    window.location.href = apiurl;
}

export function apiSsoLogout (callback)
{
    var apiurl = ssoHost + "/logout";
    window.location.href = apiurl;
}



export function apiSsoGetDomain()
{
    return ssoDomain;
}



//  *************************************************************************************************************
//  * function API GET DE BASE
// **************************************************************************************************************
export function apiSsoGetMe (token, callback)
{

    
    var myHeaders = new Headers();
    myHeaders.append('Authorization', token);

    var myInit = { method: 'GET',
                headers: myHeaders,

                cache: 'default' };

    var apiurl = ssoHost+"/me";
 
    fetch(apiurl,myInit)
    .then((response) => {
    if (!response.ok) {
        if (callback !== null) callback(null);
    }
    
    return response.json();
    })
    .then((actualData) => {

        if (callback !== null) callback(actualData);
    })
    .catch((err) => {
        if (callback !== null) callback(null);
    });    
}


var localHost = "?";





export function initlocalhost()
{
    if (window.location.hostname === "otto.myotto.fr")
        localHost  = "https://apiotto.myotto.fr/";
    else
        localHost  = "https://neweasysubapi.easydirect.fr/";

}

export function getlocalhostDatas()
{
    if (window.location.hostname === "otto.myotto.fr")
        return "https://datasotto.myotto.fr/";
    else
        return  "https://neweasysubdatas.easydirect.fr/";
}

export function getVideoPath (video)
{
    console.log("Get Video path with ", video)
    var videofile = video.vifile + "/" + video.viconvfile +".mp4";
    if ((video.viconv == -3) || (video.viconv==-2)) // fichier non converti 
      videofile = video.vifile + "/" + video.vifile+"." + video.viext;

    
    if (window.location.hostname === "otto.myotto.fr")
        videofile  = "https://datasotto.myotto.fr/videos/" + videofile;
    else
        videofile  = "https://neweasysubdatas.easydirect.fr/videos/" + videofile;

    return videofile;

}

export function getCpPaths(video)
{
    if (video.vixcp != -3)
    {
        return {json:"", jpegs:""};
    }
    var jsonfile = video.vifile+"/"+video.vixcpfile +"_cp.json";
    var jpegsfile = video.vifile+"/"+video.vixcpfile +"_cp.jpegs";

    if (window.location.hostname === "otto.myotto.fr")
    {
        jsonfile  = "https://datasotto.myotto.fr/videos/" + jsonfile;
        jpegsfile  = "https://datasotto.myotto.fr/videos/" + jpegsfile;
    }

    else
    {
        jsonfile  = "https://neweasysubdatas.easydirect.fr/videos/" + jsonfile;
        jpegsfile  = "https://neweasysubdatas.easydirect.fr/videos/" + jpegsfile;
    }

    return {json:jsonfile, jpegs:jpegsfile};
}

export function getAudioPath (channel,video)
{

    if (video.vixaudio != -3) return "";
    if (video.vinbaudio < channel ) return "";
    


    var audiofile = video.vifile+"/"+video.vixaudiofile1 +"_1.wf";
    if (channel == 2)
        audiofile = video.vifile+"/"+video.vixaudiofile2 +"_2.wf";

    if (window.location.hostname === "otto.myotto.fr")
        audiofile  = "https://datasotto.myotto.fr/videos/" + audiofile;
    else
        audiofile  = "https://neweasysubdatas.easydirect.fr/videos/" + audiofile;

    return audiofile;

}



function getUserToken()
{

    var userdatas = localStorage.getItem("userdatas");
    
    if (userdatas != null)
    try
    { 
        userdatas = JSON.parse(userdatas);
        userdatas = userdatas.token;
    }
    catch(e)
    {
        
        userdatas = null;
    }
    return userdatas;

}


export function apiGetUserDatas (email,pwd, callback)
{

    var datas = {
        mail: email.toLowerCase(),
        password : pwd,
        }
        var myHeaders = new Headers();

        myHeaders.append('Accept','application/json');
        myHeaders.append('Content-Type','application/json');
        var myInit = { method: 'POST',
                headers: myHeaders,
                mode: 'cors',
                cache: 'default',
                body: JSON.stringify(datas)
                    };

        var apiurl = localHost + "getusertoken";

        

        fetch(apiurl,myInit)
        .then((response) => {
        if (!response.ok) 
        {
            if (callback !== null) callback(null);
        }

        return response.json();
    })
    .then((actualData) => {
        if (callback !== null) callback(actualData);

    })
    .catch((err) => {
        if (callback !== null) callback(null);
    
    });

}
//  *************************************************************************************************************
//  * function API GET DE BASE
// **************************************************************************************************************
function apiGet (sd, callback)
{

    
    var myHeaders = new Headers();
    myHeaders.append('Authorization', getUserToken());

    var myInit = { method: 'GET',
                headers: myHeaders,
                mode: 'cors',
                cache: 'default' };

    var apiurl = localHost + sd;
 
    fetch(apiurl,myInit)
    .then((response) => {
    if (!response.ok) {
        if (callback !== null) callback(null);
    }
    
    return response.json();
    })
    .then((actualData) => {

        if (callback !== null) callback(actualData);
    })
    .catch((err) => {
        if (callback !== null) callback(null);
    });    
}

//  *************************************************************************************************************
//  * function API POST DE BASE
// **************************************************************************************************************
function apiPost (sd, datas, callback, nojson=false)
{
        var myHeaders = new Headers();

        if (!nojson)
        {
            myHeaders.append('Accept','application/json');
            myHeaders.append('Content-Type','application/json');
        }
        myHeaders.append('Authorization', getUserToken());

        var myInit = { method: 'POST',
                headers: myHeaders,
                mode: 'cors',
                cache: 'default',
        };

        if (nojson)
            myInit.body = datas;
        else
            myInit.body = JSON.stringify(datas);

        var apiurl = localHost + sd;


        fetch(apiurl,myInit)
        .then((response) => {
        if (!response.ok) 
        {

            if (callback !== null) callback({ret:false});
            return;
        }

        return response.json();
    })
    .then((actualData) => {

        if (callback !== null) callback(actualData);

    })
    .catch((err) => {
        console.log(err)
        if (callback !== null) callback({ret:false});
    
    });

}


//  *************************************************************************************************************
//  * function API DELETE DE BASE
// **************************************************************************************************************
function apiDelete (sd, datas, callback)
{
        var myHeaders = new Headers();

        myHeaders.append('Accept','application/json');
        myHeaders.append('Content-Type','application/json');
        myHeaders.append('Authorization', getUserToken());

        var myInit = { method: 'DELETE',
                headers: myHeaders,
                mode: 'cors',
                cache: 'default',
        };
        myInit.body = JSON.stringify(datas);
        var apiurl = localHost + sd;
        fetch(apiurl,myInit)
        .then((response) => {
        if (!response.ok) 
        {
            if (callback !== null) callback({ret:false});
            return;
        }
        return response.json();
    })
    .then((actualData) => {
        if (callback !== null) callback(actualData);

    })
    .catch((err) => {
        console.log(err)
        if (callback !== null) callback({ret:false});
    
    });
}

//  *************************************************************************************************************
//  * function API PUT DE BASE
// **************************************************************************************************************
function apiPut (sd, datas, callback)
{
        var myHeaders = new Headers();

        myHeaders.append('Accept','application/json');
        myHeaders.append('Content-Type','application/json');
        myHeaders.append('Authorization', getUserToken());

        var myInit = { method: 'PUT',
                headers: myHeaders,
                mode: 'cors',
                cache: 'default',
        };
        myInit.body = JSON.stringify(datas);
        var apiurl = localHost + sd;
        fetch(apiurl,myInit)
        .then((response) => {
        if (!response.ok) 
        {
            if (callback !== null) callback({ret:false});
            return;
        }
        return response.json();
    })
    .then((actualData) => {
        if (callback !== null) callback(actualData);

    })
    .catch((err) => {
        console.log(err)
        if (callback !== null) callback({ret:false});
    
    });
}

//  *************************************************************************************************************
//  * API USERS 
// **************************************************************************************************************

export function apiGetUserList (callback)
{
    apiGet("getusers", callback);
}

export function apiWriteUserDatas ( datas, callback)
{
    apiPost ("updateuser", datas, callback);
}


//  *************************************************************************************************************
//  * API UPLOAD 
// **************************************************************************************************************
export function apiUploadSendChunk(filename, filesize,chunk, chunkIndex, chunkSize,  totalChunks,callback)
{

    var json = {
        filename: filename,
        chunkindex: chunkIndex,
        totalchunks: Math.ceil(totalChunks),
        filesize: filesize,
        chunksize: chunkSize,

    }

    const formData = new FormData();
    formData.append ('json', JSON.stringify(json));
    formData.append('chunk', chunk);
    apiPost("uploadfile", formData, callback, true);
  }


//  *************************************************************************************************************
//  * API CLIENTS
// **************************************************************************************************************
export function apiCreateClients ( datas, callback)
{
    console.log("CREATE CLIENT", datas)
    apiPost ("table/clients", datas, callback);
}
export function apiGetClientsList (callback)
{
    apiGet("table/clients", callback);
}
export function apiDeleteClients ( datas, callback)
{
    console.log("DELETE CLIENT", datas)
    apiDelete ("table/clients", datas, callback);
}

export function apiUpdateClients ( datas, callback)
{
    console.log("update CLIENT", datas)
    apiPut ("table/clients", datas, callback);
}


//  *************************************************************************************************************
//  * API DIFFUSORS
// **************************************************************************************************************
export function apiCreateDiffusors ( datas, callback)
{
    console.log("CREATE DIFFUSOR", datas)
    apiPost ("table/diffusors", datas, callback);
}
export function apiGetDiffusorsList (callback)
{
    apiGet("table/diffusors", callback);
}
export function apiDeleteDiffusors ( datas, callback)
{
    console.log("DELETE DIFFUSOR", datas)
    apiDelete ("table/diffusors", datas, callback);
}

export function apiUpdateDiffusors ( datas, callback)
{
    console.log("update DIFFUSOR", datas)
    apiPut ("table/diffusors", datas, callback);
}


//  *************************************************************************************************************
//  * API Series
// **************************************************************************************************************
export function apiCreateSeries ( datas, callback)
{
    console.log("CREATE SEries", datas)
    apiPost ("table/series", datas, callback);
}
export function apiGetSeriesList (callback)
{
    apiGet("table/series", callback);
}
export function apiDeleteSeries ( datas, callback)
{
    console.log("DELETE Serie", datas)
    apiDelete ("table/series", datas, callback);
}

export function apiUpdateSeries ( datas, callback)
{
    console.log("Update series", datas)
    apiPut ("table/series", datas, callback);
}

//  *************************************************************************************************************
//  * API Project
// **************************************************************************************************************
export function apiCreateProjects ( datas, callback)
{
    console.log("CREATE projets", datas)
    apiPost ("table/projects", datas, callback);
}

export function apiGetSearchProjects(datas, callback)
{
    apiPost ("table/searchprojects", datas, callback);
}

export function apiGetOneProject(datas, callback)
{
    apiPost ("table/readoneproject", datas, callback);
}


export function apiGetProjectsList (callback)
{
    apiGet("table/projects", callback);
}

export function apiDeleteProjects ( datas, callback)
{
    console.log("DELETE projetcs", datas)
    apiDelete ("table/projects", datas, callback);
}

export function apiUpdateProjects ( datas, callback)
{
    console.log("Update projects", datas)
    apiPut ("table/projects", datas, callback);
}
export function apiChangeProjectUser ( datas, callback)
{
    console.log("change project user", datas)
    apiPost ("table/changeprojectuser", datas, callback);
}

//  *************************************************************************************************************
//  * API Assets
// **************************************************************************************************************
export function apiSearchAssetsFromProject(datas, callback)
{
    console.log("Search assets from projects ", datas)
    apiPost ("/table/searchassets", datas, callback);
}

export function apiCreateOneAsset ( datas, callback)
{
    console.log("Create One Assets", datas)
    apiPost ("table/assets", datas, callback);
}
export function apiCreateFromAsset ( datas, callback)
{
    console.log("Create from Assets Assets", datas)
    apiPost ("table/copyassets", datas, callback);
}
export function apiReadOneAsset ( datas, callback)
{
    console.log("Read one asset", datas)
    apiPost ("table/readoneasset", datas, callback);
}
export function apiDeleteAsset ( datas, callback)
{
    console.log("DELETE Assets", datas)
    apiDelete ("table/assets", datas, callback);
}


export function apiUpdateAsset ( datas, callback)
{
    console.log("Update Assets", datas)
    apiPut ("table/assets", datas, callback);
}

export function apiSaveAsset ( datas, callback)
{
    console.log("save Assets", datas)
    apiPut ("table/saveassets", datas, callback);
}

//  *************************************************************************************************************
//  * Miscellianous API
// **************************************************************************************************************
// Lecture de la liste des languages
export function apiGetLanguagesList (callback)
{
    console.log("lecture de la liste des languages")
    apiGet("miscellianous/languages", callback);
}


//  *************************************************************************************************************
//  * VIDEOS API
// **************************************************************************************************************
// Création d'une nouvelle vidéo...
export function apiCreateNewVideoFromUpload (datas, callback)
{
    console.log("Creation d'une nouvelle vidéo from upload ", datas)
    apiPost("/videos/createfromupload", datas, callback);
}

export function apiReadOneVideo (datas, callback)
{
    console.log("Lecture d'une vidéo ", datas)
    apiPost("/videos/readonevideo", datas, callback);
}

export function ApiUpdateAssetVideo(datas, callback)
{
    console.log("update asset video ", datas)
    apiPut("/videos/updateasset", datas, callback)
}

export function ApiDeleteAssetVideo(datas, callback)
{
    console.log("Delete asset video ", datas)
    apiDelete("/videos/deleteasset", datas, callback)
}

export function ApiGetVideoShortList(datas, callback)
{
    console.log("Get Video short list", datas)
    apiPost("/videos/videolist", datas, callback)
}

